import React, { useEffect, useState } from "react";
import CopyButton from "../CopyButton";
import Prism from "prismjs";


export const CodeWindow = ({tabs}) => {
    const [activeTab, setActiveTab] = useState(0);

    const ref = React.useRef(null);

    useEffect(() => {
        if (ref.current) {
            Prism.highlightElement(ref.current, false);
        }
    }, [activeTab]);

    return <><div className="container__code">
        <div className="code">
            <div className="logo">
                <img height="20px" width="20px" src="https://www.datocms-assets.com/86369/1700002759-covalent_logomark_white.svg" alt="covalent-logo"/>
            </div>
            {tabs.map((o, i) => {
                return <div className={`tab ${activeTab === i && "active"}`} key={i} onClick={()=>{setActiveTab(i);}}>{o.title}</div>;
            })}

            <div className="copy">
                <CopyButton text={tabs[activeTab].code}/>
            </div>
        </div>
        <div className="result__code language-typescript" ref={ref}>
            {tabs[activeTab].code}
        </div>

    </div>
    <style jsx>
        {`
        .container__code {
            min-width: 200px;
            width: 100%;
            border-radius: 0.75rem;
            background: var(--light);
            border: 1px solid var(--code-border);
            z-index: 11;
            position: inherit;
            white-space: pre;
            transition: 0.2s;
        }
        .container__code:hover {
            box-shadow: 0px 7px 17px -16px grey;
            transition: 0.2s;
        }
        :global(.dark .container__code) {
            background: var(--covalent-dark-blue);
        }
        @keyframes backgroundGradient {
            0% {
                background-position: 0% 50%;
            }
            100% {
                background-position: 100% 50%;
            }
        }
        :global(.dark .container__code::before) {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: linear-gradient(45deg, var(--pink), var(--teal));
            z-index: -1;
            filter: blur(8px);
            border-radius: calc(var(--border-radius) * 4);
            animation: backgroundGradient 4s ease-in-out infinite alternate;
            background-size: 200% 200%;
            opacity: 0.85;
            transition: all 0.3s ease-in-out;
        }

        :global(.dark .container__code::after) {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: var(--covalent-dark-blue);
            z-index: -1;
            border-radius: calc(var(--border-radius) * 4);
            opacity: 0.85;
        }

        :global(.dark .container__code:hover::before) {
            filter: blur(10px);
            opacity: 1;
        }
        .copy{
            display:flex;
            flex-grow:1;
            color:white;
            justify-content:flex-end;
        }
        .code {
            width: 100%;
            z-index: 10;
            position: inherit;
            display: flex;
            place-items: center;
            border-bottom: 1px solid var(--code-border);
        }
        .logo {
            display: flex;
            place-items: center;
            height: 32px;
            padding-left: 0.5rem;
            padding-right: 0.5rem;
        }
        .dots {
            display: flex;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            padding: 0 1rem;
            width: 85px;
            height: 32px;
            place-items: center;
        }
        .dots > div {
            width: .75rem;
            height: .75rem;
            border-radius: 100%;
            background: var(--code-border);
        }
        :global(.dark .dots > div) {
            background: #f6f0f236;
        }
        .points {
            display: flex;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            padding: 0 1rem;
            width: 50px;
            height: 32px;
            place-items: center;
            margin-left: auto;
            opacity: 0.6
        }
        .points > div {
            width: 2px;
            height: 2px;
            border-radius: 100%;
            background: var(--text);
        }
        .tab {
            color: var(--text);
            background: var(--code-background);
            opacity:80%;
            border-left: 1px solid var(--code-border);
            border-right: 1px solid var(--code-border);
            margin-top: -9px;
            margin-bottom: -9px;
            height: 32px;
            display: flex;
            place-items: center;
            padding: 0rem 1rem;
            font-size: var(--font-size-1);
            cursor: pointer;
        }
        .tab.active {
            opacity:100%;
            background: #77697d63;
        }
        .hero-code{
            max-width:30rem;

        }
        .token.string, .token.number, .token.boolean, .token.null {
            color:red!important;
        }
        :global(.code__feature__tabs .variable) {
            color: var(--pink);
        }

        .code__feature__container{
            margin: 1rem 0 2rem 0;

        }

        .result__code {
            
            white-space: pre;
            color: var(--text);
            font-family: var(--mono);
            overflow: hidden;
            padding: 1rem;
            max-height: 220px;
            font-size: var(--font-size-1);
            overflow: hidden;
            max-height: 265px;
            width: 100%;
            margin-left: auto;
            max-with: 100%;
            min-width: 550px;
        }

        .code__section {
           position: relative;
           width: 100%;
           max-width:40rem;
           gap: 1.5rem;
           display: flex;
           flex-direction: column;
           flex: 1;
        }
        h2 {
            line-height: 1.2;
            font-size: var(--font-size-7);
            color: var(--text);
            font-weight: 200;
            margin-bottom: 1rem;
        }
        p {
            color: var(--text);
        }
        .code__feature__content {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            margin-top: 5rem;
            gap: 5rem;
            position: inherit;
            z-index: 10;
        }
        .code__feature__inner {
            width: 100%;
            padding: var(--landing-page-padding);
            margin: 0 auto;
        }
        @media (max-width: 768px) {
            :global(.code__feature__tabs .tab-list) {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                border: none;
            }
            :global(.code__feature__tabs .tab-list-item) {
                width: max-content;
            }
            :global(.code__feature__tabs .tab-list-item:hover) {
                background: var(--code-background);
                border-bottom: none;
            }
            :global(.code__feature__tabs .tab-list-item.tab-list-active) {
                border-left: 2px solid var(--pink);
                border-bottom: none;
                background: var(--code-background);
            }
            .code__feature__content {
                margin-top: 2rem;
                gap: 3rem;
            }
        `}
    </style>
    </>;
};
